import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';

declare global {
  interface Window {
    RTCPeerConnection: RTCPeerConnection;
    mozRTCPeerConnection: RTCPeerConnection;
    webkitRTCPeerConnection: RTCPeerConnection;
    msRTCPeerConnection: RTCPeerConnection;
  }
}

@Injectable({
  providedIn: 'root'
})
export class IpService {

  ipRegex: any;

  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {
    this.ipRegex = new RegExp(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);
  }
  
  async getPublicIp() {
    //let publicIp = await this.http.get<string>('https://jsonip.com').toPromise();
    //return publicIp['ip'];
    let publicIpString = '0.0.0.0';
    return (publicIpString);
  }

  async getLocalIp() {
    let localIp = '';

    await new Promise((resolve, reject) => {

      //window.RTCPeerConnection = this.getRTCPeerConnection();

      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel('');
      pc.createOffer().then(pc.setLocalDescription.bind(pc));

      pc.onicecandidate = (ice) => {
        this.zone.run(() => {
          if (!ice || !ice.candidate || !ice.candidate.candidate) {
            resolve(true);
            return;
          }

          let result = this.ipRegex.exec(ice.candidate.candidate);
          localIp = (typeof result !== 'undefined' && result != null) ? result[1] : '';

          pc.onicecandidate = () => { };
          pc.close();
          resolve(true);
        });
      };

      (      error: any) => reject(error);
    });

    return localIp;
  }

  getRTCPeerConnection() {
    return window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection || 
      window.msRTCPeerConnection;
  }
}
